import { get, isNumber } from "@chakra-ui/utils";
import { logical } from "./logical-prop";
import { positiveOrNegative } from "./positive-or-negative";
export * from "./positive-or-negative";
export * from "./sort";
export * from "./types";
export * from "./logical-prop";
export function makeConfig(scale, transform) {
  return function (prop) {
    var result = {
      scale: scale
    };
    if (transform) result.transform = transform;
    if (Array.isArray(prop)) result.properties = prop;else result.property = prop;
    return result;
  };
}

function fractionalValue(value, scale) {
  var defaultValue = !isNumber(value) || value > 1 ? value : value * 100 + "%";
  return get(scale, value, defaultValue);
}

export var t = {
  borderWidths: makeConfig("borderWidths"),
  borderStyles: makeConfig("borderStyles"),
  colors: makeConfig("colors"),
  borders: makeConfig("borders"),
  radii: makeConfig("radii"),
  space: makeConfig("space"),
  spaceT: makeConfig("space", positiveOrNegative),
  prop: function prop(property, transform) {
    return {
      property: property,
      transform: transform
    };
  },
  sizes: makeConfig("sizes"),
  sizesT: makeConfig("sizes", fractionalValue),
  shadows: makeConfig("shadows"),
  logical: logical
};